import { WeenatColor } from '@weenat/theme'
import { isNil } from 'lodash-es'
import { memo } from 'react'
import { IconComponent } from '../Icon'
import Text from '../Text'
import Ripple from './Ripple'

interface EmptyStateWithRippleProps {
  Icon: IconComponent
  title?: string
  description?: string
  tint?: WeenatColor
}

const EmptyStateWithRipple: FC<EmptyStateWithRippleProps> = ({
  Icon,
  title,
  description,
  tint,
  children
}) => {
  return (
    <Flex
      $flex={1}
      $flexDirection='column'
      $alignItems='center'
      $justifyContent='center'
      $gap={'md'}
    >
      <Ripple tint={tint}>
        <Icon $size='xl' $color={tint ?? 'grayscale.700'} />
      </Ripple>
      <Flex $flexDirection='column' $gap={'sm'}>
        {!isNil(title) ? (
          <Text $fontWeight='bold' $textAlign='center'>
            {title}
          </Text>
        ) : null}
        {!isNil(description) ? <Text $textAlign='center'>{description}</Text> : null}
      </Flex>
      {children}
    </Flex>
  )
}

export default memo(EmptyStateWithRipple)
